module.exports = __webpack_public_path__ + "img/s.57a9b69d.webp";